import { ApiService } from "./AbstractApiService";
import { IPageModel } from "@/interfaces/iPageModel";
import qs from "qs";
import {
  IDashboardFormsDetail,
  IDashboardSitesDetail,
  IDashboardUsersDetail,
} from "@/interfaces/iDashboard";
import API from "./handlers/base.service";
export class DashboardAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: DashboardAPI | null;
  constructor() {
    super("document/statistics");
  }
  public async getFormsDetail(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IDashboardFormsDetail>> {
    return this.get("formsDetail", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getSitesDetail(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IDashboardSitesDetail>> {
    return this.get("sitesDetail", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getUsersDetail(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IDashboardUsersDetail>> {
    return this.get("usersDetail", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // SiteDashboard API Calls
  public async getSiteCounters(params?: Record<string, string | number>) {
    return API.get("security/clients/count?status=ACTIVE", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public getSiteChartData(startDate, endDate) {
    const params = { startDate, endDate };
    return this.get(`formCategory?status=ACTIVE`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // FormDashboard API Calls
  public getLineChartData(
    startDate,
    endDate,
    url,
    id,
    siteIds: string | number = ""
  ) {
    let params = {};
    if (id > 0) {
      if (url === "site") {
        params = { startDate, endDate, siteId: id };
      }
      if (url === "form") {
        params = { startDate, endDate, formId: id };
      }
      if (url === "user") {
        params = { startDate, endDate, userId: id, siteIds: siteIds };
      }
    } else {
      params = { startDate, endDate };
    }
    return this.get(`${url}`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public getFormOnTimeData(startDate, endDate) {
    const params = { startDate, endDate };
    return this.get(`onTime?status=ACTIVE`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public getFormOutsidePeriodData(startDate, endDate) {
    const params = { startDate, endDate };
    return this.get(`outsidePeriod?status=ACTIVE`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public getFormExpiredData(startDate, endDate) {
    const params = { startDate, endDate };
    return this.get(`expired?status=ACTIVE`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // UserDashboard API Calls
  public getUserChartData(startDate, endDate) {
    const params = { startDate, endDate };
    return this.get(`formRole?status=ACTIVE`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public getUserUniqueRoles() {
    return API.get("security/roles/all?status=ACTIVE", {}).then(
      (response) => response.data
    );
  }
}
